import React from 'react';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { BtnModalTable } from '../../styled-components';
import { useAlert } from 'react-alert';
import { useHistory } from 'react-router-dom';
import { useLoading } from '../../commons/Loading';

function ActionsField(props) {
  const { data } = props;

  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation('CONDOS');
  const { showLoading, hideLoading } = useLoading();

  const history = useHistory();

  return (
    <React.Fragment>
      <div className="flex-check">
        <BtnModalTable
          type="button"
          className="mx-2 px-2"
          onClick={(event) => {
            event.stopPropagation();
            history.push(`/my-eon-condos/${data._id}`);
          }}
        >
          {t('INFO_CONDO')}
        </BtnModalTable>
      </div>
    </React.Fragment>
  );
}

export default ActionsField;
